import { z } from 'zod/v4'

export const BusinessCustomerValidator = z.object({
        address1: z.string(),
        address2: z.string(),
        city: z.string(),
        h3cell: z.string(),
        iso_country_code: z.string(),
        latitude: z.string(),
        longitude: z.string(),
        name: z.string(),
        orders: z.null(),
        placekey: z.string(),
        sales: z.number().optional(),
        state: z.string(),
        zip: z.string(),
})

export const BusinessCustomerErrorValidator = BusinessCustomerValidator.extend({
        message: z.string(),
})

export type BusinessCustomer = z.infer<typeof BusinessCustomerValidator>
export type BusinessCustomerError = z.infer<typeof BusinessCustomerErrorValidator>
